// extracted by mini-css-extract-plugin
export var centeredImage = "columns-module--centeredImage--c930f";
export var column__black = "columns-module--column__black--f50bf";
export var column__bloodorange = "columns-module--column__bloodorange--4ba68";
export var column__border = "columns-module--column__border--c6c67";
export var column__centered = "columns-module--column__centered--ca793";
export var column__chartruse = "columns-module--column__chartruse--5c1a1";
export var column__cobalt = "columns-module--column__cobalt--ec7b3";
export var column__emerald = "columns-module--column__emerald--527f4";
export var column__left = "columns-module--column__left--00fa7";
export var column__paper = "columns-module--column__paper--093c4";
export var column__pink = "columns-module--column__pink--0b4c7";
export var column__right = "columns-module--column__right--8b84b";
export var column__sky = "columns-module--column__sky--3bb2c";
export var column__white = "columns-module--column__white--08f69";
export var noPaddingUpper = "columns-module--noPaddingUpper--8c4b4";
export var noPaddingUpperDesktop = "columns-module--noPaddingUpperDesktop--1a5cc";
export var partners = "columns-module--partners--85db6";
export var spin = "columns-module--spin--2b1cd";